import { find, last, chain, pick, toLower, get } from "lodash"
import { createSelector } from "reselect"
import { computeData } from "modules/analyze-composite-exposure/selectors/data"
import { getSelectedContributorCategoryId } from "helpers/compositeSecuritiesDetails"

const getSelectedDate = (_, props) => props.selectedDate
const getAllCategoryItems = (_, props) => props.allCategoryItems
const getExposure = (_, props) => props.exposure

export const getSelectedContributorCategory = createSelector(
  [getSelectedContributorCategoryId, getAllCategoryItems],
  (selectedId, categories) => {
    if (!selectedId) {
      return null
    }

    return find(categories, category => toLower(category.id) === toLower(selectedId))
  },
)

const getContributorData = createSelector(
  [getAllCategoryItems, getExposure],
  (items, exposure) => computeData(items, exposure),
)
const getLastContributor = createSelector(
  [getContributorData],
  last,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format("YYYY-MM-DD")) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format("YYYY-MM-DD"))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return chain(items)
      .map(item => ({
        ...pick(item, ["label", "id", "color", "category", "favorite", "field", "isAggregated"]),
        value: dayData[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  (contributors, selected) => {
    if (!selected) {
      return 0
    }

    const item = find(contributors, d => d.id === selected.id)
    return get(item, "value", 0)
  },
)
